import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { GlobalComponent } from './global/global.component';
import {  HttpHandler, HttpRequest, HttpEvent, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
@Injectable()
export class AuthService {
  url: string = ""
  constructor(private router: Router, public global: GlobalComponent, private http: HttpClient, private EnvironmentService: EnvironmentService) {
    let Ec = EnvironmentService.getEnvironmentsConfiguration();
    this.url = Ec.baseUrl;
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // for agency login & client onboarding & employee onboarding//
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == undefined || this.global.globalAgencyId == "") {
          this.global.globalAgencyId = "00000000-0000-0000-0000-000000000000";
        }
        request = request.clone({
          url: this.url + request.url,
          setHeaders: {
            'Authorization': `Bearer ` + this.global.authtoken,
            'AgencyId': this.global.globalAgencyId
          },
          withCredentials: true
        });

    return next.handle(request);
  }
}